// 画面の中で使う値（2026-10-21 に app.js から分けた。データ・カテゴリ・キャラの SVG のレイヤーは 2026-10-23 から中身の core/model.ts。ここからも使える）
export { catByKey, partsLists, layerG } from './core/model.js';
// カテゴリを選んだときの動き（印がすべる・一覧が入ってくる・アイコンが跳ねる）。メニューで切りかえ。動きを減らす設定の端末では止める
export const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
export const anim = !reduceMotion.matches;
// スマホの並び（style.css の @media と同じ条件）
export const narrowUI = window.matchMedia('(max-width: 760px), (max-aspect-ratio: 4/5)');
// 全身のメーカー（page.php の $ui['stageTall'] で .app.tall）のスマホの並び（2026-10-23〜）: クラシック版と同じく、キャラを画面いっぱいに出して UI を上に乗せる。
// 右の列に元に戻す・色・柄・左右・調整（side.ts）、グラデーションは色の列の右の縦のバー、重ね付けはまとめずに別のカテゴリ、名前はメニューから。開いたときに決める
export const tallUI = narrowUI.matches && !!document.getElementById('app') && document.getElementById('app')!.classList.contains('tall');
